import { EVENTS } from "./EVENTS";

export function externalLinkEvent(href: string) {
  return {
    ...EVENTS.COMMON.OPEN_EXTERNAL_LINK,
    label: href,
  };
}
